import { useTimer } from "react-timer-hook";
import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "./Login.scss";
import { prefixUrl } from "../../Utils/utilsData";

function MyTimer({ expiryTimestamp, type }) {
  const [disabled, setDisabled] = useState(true);
  const {
    seconds,
    minutes,
    hours,
    days,
    isRunning,
    start,
    pause,
    resume,
    restart,
  } = useTimer({
    expiryTimestamp,
    onExpire: () => setDisabled(false),
  });

  return (
    <div className="timer-component" style={{ textAlign: "center" }}>
      <button
        disabled={disabled}
        onClick={(e) => {
          e.preventDefault();
          setDisabled(true);
          // Restarts to 5 minutes timer
          const time = new Date();
          time.setTime(time.getTime() + 1000 * 120);
          restart(time);
          let data = {
            phoneNumber: localStorage.getItem("mobile"),
            fullName: localStorage.getItem("name"),
          };
          let sendUrl =
            type === "register"
              ? "/register/sendCode.php"
              : "/login/sendCode.php";
          axios.post(`${prefixUrl()}${sendUrl}`, data).then((response) => {
            if (!response.data.status) {
              toast.error(response.data.data);
            }
          });
        }}
        className="resend-btn"
      >
        ارسال مجدد کد
      </button>
      <div style={{ fontSize: "14px" }}>
        <span>{minutes}</span>:<span>{seconds}</span>
      </div>
    </div>
  );
}

export default function App({type}) {
  const time = new Date();
  time.setTime(time.getTime() + 1000 * 120);
  return (
    <div>
      <MyTimer expiryTimestamp={time} type={type} />
    </div>
  );
}
